/* global mixpanel */

export function outletListStart () {
  mixpanel.track('Outlet Start')
}

export function outletListCreate ({outlet}) {
  mixpanel.track('Outlet Create', {
    'Name': outlet.name,
    'Phone': outlet.phone_number,
    'Address': outlet.address,
    'City': outlet.city,
    'Province': outlet.province,
    'Zip': outlet.postal_code
  })
}

export function outletStart () {
  mixpanel.track('Outlet Add')
}

export function outletPay ({billingData}) {
  mixpanel.track('Outlet Add Pay', {
    'Payment Amount': billingData.total_amount,
    'Total Outlet': billingData.add_outlet_count
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/outlets/list.js